<script lang="ts">
	import type { Snippet } from "svelte";
	import { FooterContactColumn, FooterRow } from "#lib/web-ui/blocks/index.js";
	import type { Address, SocialLinks } from "#lib/web-ui/blocks/index.js";

	type ContactInfo = {
		companyName: string;
		address: Address;
		addressLink: string;
		phone: string;
		email: string;
		socialLinks: SocialLinks;
	};

	let {
		logoUrl,
		tagline,
		contactInfo,
		children
	}: {
		logoUrl: string;
		tagline: string;
		contactInfo: ContactInfo;
		children: Snippet;
	} = $props();
</script>

<FooterRow class="gap-8">
	<FooterContactColumn
		{logoUrl}
		logoAlt="Fergmar Logo"
		logoWidth={300}
		logoHeight={36}
		{tagline}
		address={contactInfo.address}
		addressLink={contactInfo.addressLink}
		socialLinks={contactInfo.socialLinks}
		class="grow"
	/>

	{@render children?.()}
</FooterRow>
